module.exports = __webpack_public_path__ + "img/12CH_PulseAlarm.3fced9fa.png";